import { CONFIG } from "@/config";
/**
 * Sides of a sheet
 * - Back is the one visible when the sheet is on the left
 * - Front is the one visible when the sheet is on the right
 */
export var SheetSide;
(function (SheetSide) {
    SheetSide[SheetSide["back"] = 0] = "back";
    SheetSide[SheetSide["front"] = 1] = "front";
})(SheetSide || (SheetSide = {}));
/** Index of the page on a sheet */
export function getPageIndex(sheet, side) {
    return sheet * 2 + (side === SheetSide.front ? -1 : 0);
}
/** Displayed number of the page on a sheet */
export function getPageNumber(sheet, side) {
    return getPageIndex(sheet, side) + CONFIG.pages.firstPageNumber;
}
/** Sheet associated to a given page number */
export function getSheetIndexFromPageNumber(page) {
    return Math.floor((page - CONFIG.pages.firstPageNumber) / 2);
}
